//Custom components

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and Miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import { capitalize, transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../UI/Card/index.tsx';
import DoughnutChart from '../../UI/Charts/DoughnutChart';
import { CurrencyFormatDisplay } from '../../UI/NumberFormatDisplay/CurrencyFormatDisplay';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

interface ProgramFinancialWidgetProps {
  dashboard: DashboardType;
}

const ProgramFinancialWidget = ({ dashboard }: ProgramFinancialWidgetProps) => {
  const fetchDashboardData = useDashboardData({
    dashboard,
    widget: Widget.PROJECT_FINANCIAL,
  });

  const programFinancialWidgetData: IProgramSubsidiesWidgetData[] = fetchDashboardData?.data?.data;

  const projectSubsidies = programFinancialWidgetData?.reduce((acc: IProgramSubsidiesData[], next: IProgramSubsidiesWidgetData) => {
    return [...acc, ...next.subsidies];
  }, []);

  const subsidies: { [key: string]: number } = {};
  projectSubsidies?.forEach((ps: IProgramSubsidiesData) => {
    if (subsidies[ps.name]) {
      subsidies[ps.name] += ps.amount;
    } else {
      subsidies[ps.name] = ps.amount;
    }
  });

  // const cclfAcquisitionProjectUses: number[] = programFinancialWidgetData?.map(
  //   (project: any) => {
  //     let usesTotal = 0;
  //     if (project.subsidies) {
  //       usesTotal += project.subsidies.reduce((acc: any, next: any) => {
  //         return acc + next.amount;
  //       }, 0);
  //     }
  //     return usesTotal;
  //   }
  // );

  const totalProjectSubsidies = projectSubsidies?.reduce((acc: number, next: IProgramSubsidiesData) => {
    return acc + next.amount;
  }, 0);

  const chartDataTransformation = Object.keys(subsidies).map((s: string) => {
    return { type: 'sub', count: subsidies[s] };
  });
  const chartDataSets = transformProjectTypeChartDataSets(chartDataTransformation);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECT_FINANCIAL}>
      {projectSubsidies && (
        <Card title='Project Subsidies' error={fetchDashboardData?.isError}>
          <div className='p-5 flex flex-col items-center '>
            <div className='w-full gap-4 items-center'>
              <h3 className='text-gray-500 text-lg'>Total Project Subsidies</h3>
              <h2 className='m-0'>{<CurrencyFormatDisplay value={totalProjectSubsidies} prefix='$' />}</h2>
            </div>
            <div className='w-5/6 lg:w-2/3 '>
              <DoughnutChart dataLabels={Object.keys(subsidies).map((k) => capitalize(k))} colors={true} datasets={chartDataSets} />
            </div>
          </div>
        </Card>
      )}
    </WidgetLayout>
  );
};

export default ProgramFinancialWidget;
